import 'venuescanner-scss/stylesheets/widgets/gnav.scss'
import { $, pageLoaded } from 'venuescanner-js/tools/elemental'
const openClass = 'gnav-open'
const gnav = {
  nav: null,
  button: null,
  init: function () {
    this.button = $('button.ux-navbar-item.explore')
    this.nav = $('.ux-gnav')
  },
  toggle: function (state) {
    if (typeof state === 'undefined') {
      state = !this.nav.hasClass(openClass)
    }
    if (state) {
      this.nav.addClass(openClass)
    } else {
      this.nav.removeClass(openClass)
    }
  }
}
if (window) {
  if (!window.main) window.main = {}
  window.main.toggleGnav = (...args) => {
    gnav.toggle(...args)
  }
  pageLoaded(() => {
    gnav.init()
  })
}
